import React, { useEffect, useState } from "react";
import { Container, Row, Col, Image, Card, Badge } from "react-bootstrap";
import "./Insurance.css";
import checkIcon from "../../assets/img/aboutus/check.svg";
import aboutBackground from "../../assets/img/aboutus/aboutBackground.svg";
import AutomobileInsurance from "./AutomobileInsurance";
import CommercilInsurance from "./CommercilInsurance";

const Insurance = () => {
  const [responsiveStatus, setResponsiveStatus] = useState(false);
  // const ITEMS_PER_PAGE = 4;

  useEffect(() => {
    const mediaQueries = {
      isSmallMobile: window.matchMedia("(max-width: 480px)"),
      isMobile: window.matchMedia("(min-width: 481px) and (max-width: 767px)"),
      isTablet: window.matchMedia("(min-width: 768px) and (max-width: 1024px)"),
      isTabletLandscape: window.matchMedia(
        "(min-width: 1025px) and (max-width: 1279px)"
      ),
      isDesktop: window.matchMedia("(min-width: 1280px)"),
    };

    const updateResponsiveStatus = () => {
      const matchingBreakpoints = Object.entries(mediaQueries)
        .filter(([, mq]) => mq.matches)
        .map(([name]) => name);

      setResponsiveStatus(matchingBreakpoints[0]);
    };

    // Initial check
    updateResponsiveStatus();

    // Add media query listeners
    const mediaListeners = Object.values(mediaQueries).map((mq) => {
      mq.addEventListener("change", updateResponsiveStatus);
      return () => mq.removeEventListener("change", updateResponsiveStatus);
    });

    // Add window resize listener
    window.addEventListener("resize", updateResponsiveStatus);

    // Cleanup all listeners on unmount
    return () => {
      mediaListeners.forEach((remove) => remove());
      window.removeEventListener("resize", updateResponsiveStatus);
    };
  }, []);

  return (
    <>
      <div
        className={`${
          responsiveStatus === "isDesktop"
            ? "py-5"
            : responsiveStatus === "isTablet" ||
              responsiveStatus === "isTabletLandscape"
            ? "py-5"
            : "py-2"
        }`}
        style={styles.container}
      >
        <Container style={{ maxWidth: "1350px", margin: "0 auto" }}>
          <Row
            className="align-items-center"
            style={{ position: "relative", left: 0, marginLeft: "0px" }}
          >
            {/* Left Column: Text Content */}
            <Col lg={6}>
              <p
                style={{
                  color: "#17252E",
                  fontSize: "21px",
                  lineHeight: "140%",
                  fontWeight: 600,
                  whiteSpace: "nowrap",
                  position: "relative",
                  display: "inline-block",
                }}
              >
                <span
                  style={{
                    position: "relative",
                    paddingBottom: "5px",
                  }}
                >
                  Your Needs, Our Priority
                  <span
                    style={{
                      content: '""',
                      position: "absolute",
                      left: 0,
                      bottom: -5,
                      height: "1.6px",
                      width: "55%", // Extend beyond text
                      backgroundColor: "#0e72d6",
                      transform: "translateX(0%)", // Centered extension
                    }}
                  />
                </span>
              </p>

              <h2
                className={`mt-2 ${
                  responsiveStatus === "isDesktop"
                    ? "h2Class"
                    : responsiveStatus === "isTablet" ||
                      responsiveStatus === "isTabletLandscape"
                    ? "h2Class"
                    : "h2Class-m"
                }`}
                style={{ marginBottom: "1em" }}
              >
                We understand what's <br /> important to you.
              </h2>

              <p className="mb-4 text-secondary">
                You'll take great comfort knowing that the products and
                coverages that we've created are nothing short of the best the
                industry has to offer. Have a look, and feel free to ask your
                local independent UAIC agent about the personalized coverages
                and policy discounts offered in your state.
              </p>

              <div className="d-flex flex-wrap gap-3">
                <ul
                  className={`flex-wrap gap-3 ${
                    responsiveStatus === "isDesktop"
                      ? "d-flex"
                      : responsiveStatus === "isTablet" ||
                        responsiveStatus === "isTabletLandscape"
                      ? "d-flex"
                      : "d-block"
                  }`}
                  style={{ listStyle: "none", padding: 0, margin: 0 }}
                >
                  {[
                    "Excellence in Coverage",
                    "Care in Service",
                    "Exceptional Value",
                  ].map((item, i) => (
                    <li
                      key={i}
                      style={{
                        marginBottom:
                          responsiveStatus === "isDesktop"
                            ? "12px"
                            : responsiveStatus === "isTablet" ||
                              responsiveStatus === "isTabletLandscape"
                            ? "12px"
                            : "0px",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <img
                        src={checkIcon}
                        alt="check"
                        style={{ width: "18px", marginRight: "10px" }}
                      />
                      <span className="aboutTextStyle">{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </Col>

            {/* Right Column: Image + Floating Cards */}
            <Col lg={6} className="position-relative mt-5 mt-lg-0 text-center ">
              {/* Circular Image */}
              <div className="uaic -image-wrapper mx-auto">
                <Image
                  src={require("../../assets/img/insurance/right_layout_image.svg")}
                  fluid
                  className="insuranceRightImage"
                  alt="Insurance Right Image"
                />
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      <AutomobileInsurance />
      <CommercilInsurance />
    </>
  );
};

const styles = {
  container: {
    display: "flex",
    flexWrap: "wrap",
    width: "100%",
    minHeight: "400px",
    fontFamily: "Arial, sans-serif",
    backgroundImage: `url(${aboutBackground})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
  },
  container1: {
    display: "flex",
    flexWrap: "wrap",
    width: "100%",
    minHeight: "400px",
    fontFamily: "Arial, sans-serif",
  },
};

export default Insurance;
